module.exports = __webpack_public_path__ + "static/anonymize-data-f90307aa2e0a960c4b148eed16e40a32.png";